<template>
  <div>
    <el-row style="margin: 20px auto">
      <el-col :xl="4" :lg="4" :md="6">
        <span>订单日期：{{SEND_DAY}}</span>
      </el-col>
      <el-col :xl="6" :lg="8" :md="12">
        <span>项目点：{{ PROJECT_NAME }}</span>
      </el-col>
      <el-col :xl="3" :lg="4" :md="6">
        <span>档口：{{DK_NAME}}</span>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px">
      <el-form :model="searchForm" ref="searchForm" :inline="true">

        <el-form-item label="出库日期：">
          <el-date-picker size="medium" v-model="searchForm.SEND_DAY" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" :clearable="true">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="项目点：">
          <label slot="label">项&nbsp;目&nbsp;&nbsp;点：{{ PROJECT_NAME }}</label>
        </el-form-item>
        <el-form-item label="产品名称：">
          <el-input size="medium" v-model="searchForm.PRODUCT_NAME"></el-input>
        </el-form-item>
        <el-form-item label="产品编码：">
          <el-input size="medium" v-model="searchForm.PRODUCT_CODE"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="medium" type="primary" @click="doQueryTable()">筛选</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-table :data="listData" border stripe @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="DELIVER_DAY" label="出库日期"></el-table-column>
        <el-table-column prop="PROJECT_NAME" label="项目点"></el-table-column>
        <el-table-column prop="PRODUCT_NAME" label="产品名称"></el-table-column>
        <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
        <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
        <el-table-column prop="BATCH" label="批次"></el-table-column>
        <el-table-column prop="DELIVER_COUNT" label="出库数量"></el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <el-col :span="2" :offset="22" style="margin-top: 24px">
        <el-button size="small" type="default" @click="allSubmit">匹配</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
    </el-row>
  </div>
</template>
<script>
// import util from '@/assets/common/util';
import http from '@/assets/common/http';

export default {
  data() {
    return {
      listData: [],
      total_count: 0,
      editFormVisible: false,
      searchForm: {
        SEND_DAY: sessionStorage.getItem('nDM_SEND_DAY'),
      },
      tableData: [],
      DK_NAME: sessionStorage.getItem('nDM_DK_NAME'),
      SEND_DAY: sessionStorage.getItem('nDM_SEND_DAY'),
      PROJECT_NAME: sessionStorage.getItem('nDM_PROJECT_NAME'),
      PROJECT_ID: sessionStorage.getItem('nDM_PROJECT_ID'),
      totalCount: 0,
      pageSize: 20,
      currentPage: 1,
      RECORD_ID_LIST: [],
    };
  },
  inject: ['reload'],
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 20;
    this.queryData();
  },
  methods: {
    // ----------------分页
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryData();
    },
    doQueryTable() {
      this.queryData();
    },
    handleSelectionChange(val) {
      this.RECORD_ID_LIST = [];

      val.map((item) => {
        this.RECORD_ID_LIST.push(item.RECORD_ID);
      });
    },
    allSubmit() {
      if (this.RECORD_ID_LIST.length == 0) {
        this.$message.show({ text: '请勾选要匹配的产品', type: 'warning' });
        return false;
      }
      this.$router.push({ name: 'matchDocument' });
      sessionStorage.setItem('nDM_RECORD_ID_LIST', JSON.stringify(this.RECORD_ID_LIST));
    },
    // 页面加载时请求的数据
    queryData() {
      const params = {
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        SERVICE_ID: '10031',
        OTYPE: 88,
        PAGE_SIZE: this.pageSize,
        PAGE_INDEX: this.currentPage - 1,
        PROJECT_ID: this.PROJECT_ID,
      };
      if (this.searchForm.SEND_DAY) {
        params.DELIVER_DAY = this.searchForm.SEND_DAY;
      }
      if (this.searchForm.PRODUCT_CODE) {
        params.PRODUCT_CODE = this.searchForm.PRODUCT_CODE;
      }
      if (this.searchForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      http.post(params).then((result) => {
        if (result.length == 0) {
          this.listData = [];
          this.totalCount = 0;
        } else {
          this.listData = result[0].LIST;
          this.totalCount = result[0].TOTAL_COUNT;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // -------------------------------------全部确认


  },
};
</script>
<style scoped>
.el-table .warning-row {
  background: pink;
}

.tableArea {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/warehouseManage/noDocumentMatching.vue